(function () {

    "use strict";

    function inputController() {
        var vm = this;
        if (vm.modoLectura) {
            vm.modoLectura = 'readonly';
        }
    }
     inputController.$inject = [];

    angular.module("sphforms.main")
        .component("sphFormsInput", {
            controller: inputController,
            bindings: {
                nameLabel: "=",
                maxLength: "=",
                model: "=",
                disable: "=",
                type: "=",
                required: "=",
                modoLectura: "=",
                change: "&"
            },
            templateUrl: "modules/main/components/ui/input/input.template.html"
        });

}());
